import AxiosService from '../AxiosService';
import { apiUrl, queryString } from '../config/globals';

export const downloadFileOrFolder = (params) => AxiosService.get(`${apiUrl('data-repository', 'private')}/download-item?${queryString(params)}`, { responseType: 'blob' });

export const repositoryList = (data, params) => AxiosService.post(`${apiUrl('data-repository', 'private')}/search?${queryString(params)}`, data);

export const getSubRepositoryList = (params) => AxiosService.get(`${apiUrl('data-repository', 'private')}/view-folder?${queryString(params)}`);

export const addRepositoryElement = (data) => AxiosService.post(`${apiUrl('data-repository', 'private')}/save`, data);

export const deleteRepositoryElement = (params) => AxiosService.delete(`${apiUrl('data-repository', 'private')}/delete-item?${queryString(params)}`);

export const renameRepositoryElement = (data) => AxiosService.put(`${apiUrl('data-repository', 'private')}/rename`, data);
